import { BidderCatalog } from '@pubstack/common/src/bidderCatalog'
import { FunctionComponent } from 'react'
import { Flyout } from '~/components/Flyout'
import { Product } from '~/hooks/useProduct'
import { CreateSeatStepper } from './CreateSeatStepper'

type Props = {
  scopeId: string
  /** `spark-demand` is the internal Spark seat: the same stepper, over the compatible-bidder list. */
  type: 'pbs' | 'spark-demand'
  preselectedBidderCatalog?: BidderCatalog
  onSeatCreated: (name: string, product: Product) => void
  onClose: () => void
}

export const CreateSeatFlyout: FunctionComponent<Props> = ({ scopeId, type, preselectedBidderCatalog, onClose, onSeatCreated }) => {
  const isSparkDemand = type === 'spark-demand'

  return (
    <Flyout.Content>
      <Flyout.Title>
        {isSparkDemand ? (
          'New Spark Demand seat'
        ) : preselectedBidderCatalog ? (
          <>
            <div className="font-rubik text-xl leading-[1.875rem] whitespace-normal">New seat - {preselectedBidderCatalog.displayName}</div>
            <div className="font-roboto text-base leading-[1.625rem] font-normal whitespace-normal text-hurricane">Set up how to map ad units to {preselectedBidderCatalog.displayName}</div>
          </>
        ) : (
          'New seat'
        )}
      </Flyout.Title>
      <CreateSeatStepper scopeId={scopeId} variant={isSparkDemand ? 'spark-demand' : 'catalog'} preselectedBidderCatalog={preselectedBidderCatalog} onSeatCreated={onSeatCreated} onClose={onClose} />
    </Flyout.Content>
  )
}
